<div class="body-container mx-auto">
  <header>
    <h1 class="page-title text-center">
      Forgot Password
    </h1>
  </header>
  <div class="reg-form-content">
    <p class="page-subtitle text-center mt-3 mb-4">Enter your email to receive a verification code to reset your
      password</p>
  </div>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <div class="input-container">
      <span class="input-label">Email Address</span>
      <input
        type="text"
        class="input"
        formControlName="email"
      >
      <span
        class="error"
        *ngIf="f.email.touched && f.email.value === ''"
      >Please enter email address.</span>
      <span
        class="error"
        *ngIf="f.email.touched && f.email.status === 'INVALID' && f.email.value !== ''"
      >Please check email address. E.g. woof@example.com</span>
    </div>
    <div class="action-container">
      <button
        type="submit"
        class="btn btn-danger btn-block"
        [disabled]="!form.valid"
      >Send Verification Code</button>
      <button
        type="button"
        class="btn btn-block btn-outline-danger"
        (click)="cancel()"
      >Cancel</button>
    </div>
  </form>
</div>